var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-fill"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('view-Register-verify.title'))+" ")]),_c('div',{staticClass:"text-center"},[_c('b-spinner')],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }